import { IManagedUser } from "../../../../models/User";

export interface IUsersReferenceStepTwoProps {
  selectedUser: IManagedUser;
  usersManagedList: any[];
  usersManagedLoader: boolean;
  userEntitlements: any;
  entitlementsOfBRSelected: any[];
  secondaryManagers: any[];
  secondaryOus: any[];
  userDetailRequest: (id: string) => {};
  usersManagedRequest: (userCode: string) => {};
  usersEntitlementRequest: (id: any[]) => {};
  changeLocation: (url: string) => {};
  setEntitlementsBRSelected: (entitlements: any) => {};
  entitlementsListBusinessRolesSelectedReset: () => {};
  getUserManagers: (userCode: string) => void;
  getUserOus: (userCode: string) => void;
}

export const TypeFilterUsersManaged = {
  idFilter: "id",
  codeFilter: "code",
  statusFilter: "stato",
  applicationFilter: "application_name",
  forceChangePwdFilter: "forceChangePwd",
  numberLoginErrorFilter: "numberLoginError",
  lastChangePwdFilter: "lastChangePwd",
};
export const TypeFilterEntitlements = {
  applicationFilter: "application_name",
  applicationDescriptionFilter: "application_description",
  entitlementFilter: "entitlement_name",
  entitlementDescriptionFilter: "entitlement_description",
  identitySystemIdFilter: "identitySystemId",
};
export const ManagerTypeFilter = {
  userCodeFilter: "code",
  organizationalUnitFilter: "ouDescription",
  managerFilter: "resp_full_name",
  identitySystemIdFilter: "identitySystem",
};
export const OuTypeFilter = {
  idFilter: "id",
  nameFilter: "name",
  descriptionFilter: "description",
  ownerFilter: "owner",
  identitySystemIdFilter: "identitySystem",
};

export const USER_REFERENCE_DETAIL_USERS_FORM_FILTER: string =
  "UserReferencesDetailUsersFormFilter";
export const USER_REFERENCE_DETAIL_ENTITLEMENTS_FORM_FILTER: string =
  "UserReferencesDetailEntitlementsFormFilter";
export const USER_REFERENCE_DETAIL_MANAGERS_FORM_FILTER: string =
  "UserReferencesDetailManagersFormFilter";
export const USER_REFERENCE_DETAIL_OUS_FORM_FILTER: string =
  "UserReferencesDetailOusFormFilter";

export const mockAbilitation: any[] = [
  {
    id: 1,
    application: "AD Infrastruttura",
    username: "ADInfra",
    state: "active",
    change_password: true,
    last_password_change: "12/12/2020",
    login_error: 2,
  },
  {
    id: 2,
    application: "AD Infrastruttura",
    username: "ADInfra",
    state: "sospesp",
    change_password: false,
    last_password_change: "12/12/2020",
    login_error: 0,
  },
  {
    id: 1,
    application: "Database",
    username: "DBLiquid",
    state: "active",
    change_password: true,
    last_password_change: "12/12/2020",
    login_error: 2,
  },
];
